export function getMIMESubtype(mimeType: string) {
  const result = mimeType.match(/^\w+\/(?:x\-)?(\w+)(?:\+\w+)?/);
  if (!result) throw new Error(`Encountered malformed MIME type string: ${mimeType}`)
  else return result[1]
}

